import { render, staticRenderFns } from "./WildObstacleActions.vue?vue&type=template&id=5ba51b32&scoped=true"
import script from "./WildObstacleActions.vue?vue&type=script&lang=js"
export * from "./WildObstacleActions.vue?vue&type=script&lang=js"
import style0 from "./WildObstacleActions.vue?vue&type=style&index=0&id=5ba51b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba51b32",
  null
  
)

export default component.exports